import React from 'react';

import ProposedChanges from '../ProposedChanges/ProposedChanges';

class Rules extends React.Component {
    render() {
        return (
            <div id="rulesContainer">
                {/* <ProposedChanges/> */}
                <h2>Current Rules</h2>
                <ul>
                    <li>Rosters/Contracts</li>
                    <ul>
                        <li>The contract cap is 34 years, and you are allowed to have 17 players</li>
                        <li>Once a player is given a contract that contract is permanent and persists through trades. Contracts cannot be reallocated at any time</li>
                        <li>Contracts can be terminated only if the player is cut from the roster; once picked back up that player is then assigned a new contract.</li>
                        <li>2 year max contracts on all free agent pickups <b>after</b> the beginning of week 3. "undrafted" players can get 3/4 years</li>
                        <li>If you have reached the maximum years of 34 and still have roster spots available you CANNOT pick up any additional players</li>
                        <li>A player on the IR does not count toward the number of contract years or take up a roster slot, two IR players MAX per team</li>
                        <li>Once the trade deadline has passed, players are ONLY allowed to be given 1 year deals</li>
                        <li>One player that is on an expiring deal is allowed to be franchise tagged for the next season, once tagged this player cannot be tagged again the following year by his team or any other team</li>
                    </ul>
                    <li>Draft</li>
                    <ul>
                        <li>Each draft consists of 7 rounds</li>
                        <li>A lottery will take place prior to the draft to order places 1-6, places 7-12 are in reverse order of the playoff finishes</li>
                        <li>In an effort to prevent throwing games, places 7-12 in the regular season are randomly seeded into draft slots 1-6</li>
                        <li>Once the draft is concluded, each team must assign their draft picks contract years. One drafted player can be given a 4 year contarct, all others must be given 1-3 years</li>
                        <li>Waivers will begin after the draft results are set online, players picked up before the start of week 1 are considered undrafted and fall under the same contract rules as drafted players</li>
                    </ul>
                    <li>A player dropped cannot be picked up by the same team, but if he goes through the waiver wire the same team may pick him up again and give him a new contract</li>
                    <li>There is a sacko tournament that runs at the same time as the playoffs, the winner of the sacko tournament is decalred sacko and is subject to punishment upheld by the league</li>
                </ul>
                <h3>2022 Rule Changes</h3>
                <ul>
                    <li>2026 Draft will be a 2-round snake rookie draft followed by an auction draft.</li>
                    <li>"Battle Royale" style week 1 and 14, top 6 scores get a win, others get a loss. Sacko plays champion twice, 11th plays 2nd twice...</li>
                    {/* <li>2 year max contracts on all free agent pickups <b>after</b> the beginning of week <b>3</b>. "undrafted" players can get 3/4 years</li> */}
                </ul>
                <h3>2021 Rule Changes</h3>
                <ul>
                    <li>Move league to <a href="https://football.fantasysports.yahoo.com/f1/93183" target="_blank" rel="noopener noreferrer">Yahoo</a></li>
                    <li>Even lottery odds for teams that miss playoffs</li>
                    <li>2 year max contracts on all free agent pickups <b>after</b> the beginning of week 1. "undrafted" players can get 3/4 years</li>
                    <li>Franchise tags will be due a few days after the NFL draft </li>
                </ul>
                <h3>2020 Rule Changes</h3>
                <ul>
                    <li>Move league to MFL</li>
                </ul>
                <h3>2019 Rule Changes</h3>
                <ul>
                    <li>Move league to Yahoo</li>
                    <li>Added half point PPR/half point first down</li>
                </ul>
                <h3>2018 Rule Changes</h3>
            </div>
        );
    }
}

export default Rules;